<div class="flex flex-col gap-6">
  <div class="flex flex-col gap-2">
    <xemex-installation-insights-configuration></xemex-installation-insights-configuration>
    @if (showZone()) {
      <p class="text-xs text-text-secondary text-right">
        {{ 'installations.insights.zone' | translate: { zone: timezone() } }}
      </p>
    }
  </div>

  @if (!hasActivePoints()) {
    <xemex-no-items-found
      NoItemsIllustration="device"
      [message]="'installations.insights.noPoints'"
      [showRefresh]="false"
      [link]="dataSourcesLink()"
      [linkLabel]="'installations.insights.openDataSources'"
    ></xemex-no-items-found>
  } @else if (telemetryStore.notShared()) {
    <xemex-no-items-found
      NoItemsIllustration="device"
      [message]="'installations.insights.notShared'"
      [showRefresh]="false"
    ></xemex-no-items-found>
  } @else {
    @if (telemetryStore.failed()) {
      <div class="flex items-center justify-between gap-4 rounded-lg bg-status-neutral p-4">
        <span>{{ 'installations.insights.failed' | translate }}</span>
        <xemex-text-button icon="refresh" (click)="retry()">
          {{ 'installations.insights.retry' | translate }}
        </xemex-text-button>
      </div>
    }
    <xemex-card-grid>
      @for (item of gridItems(); track item.key) {
        @if (item.card; as card) {
          <xemex-card
            [class]="item.main ? 'md:col-span-2 !w-full' : ''"
            [title]="
              (card.titleKey ? (card.titleKey | translate) : card.title) +
              (card.sourceLabel ? ' – ' + card.sourceLabel : '')
            "
          >
            @let hasData = telemetryStore.isLoading() || labels().length > 0;
            @let totals = telemetryStore.isLoading() ? undefined : totalsByCard().get(card.key);
            @if (totals || (hasData && hasBarSeries(card))) {
              <div cardHeaderActions class="card-header-actions">
                @if (totals) {
                  <div class="period-totals" data-testid="period-totals">
                    @for (total of totals; track total.key) {
                      <div class="period-totals__item">
                        <span class="period-totals__label">{{ total.label }}</span>
                        <span class="period-totals__value">{{ total.value }}</span>
                      </div>
                    }
                  </div>
                }
                @if (hasData && hasBarSeries(card)) {
                  @let barsLabel = 'installations.insights.chartType.bar' | translate;
                  @let linesLabel = 'installations.insights.chartType.line' | translate;
                  <xemex-button-toggle
                    data-testid="chart-type-toggle"
                    [compact]="true"
                    [options]="[
                      { value: 'bar', label: '', icon: 'bar_chart', ariaLabel: barsLabel },
                      { value: 'line', label: '', icon: 'show_chart', ariaLabel: linesLabel },
                    ]"
                    [ngModel]="chartTypeOf(card.key)"
                    (ngModelChange)="setChartType(card.key, $event)"
                  ></xemex-button-toggle>
                }
              </div>
            }
            @if (!telemetryStore.isLoading() && labels().length === 0) {
              <xemex-no-items-found
                [compact]="true"
                [message]="'installations.insights.noData'"
                [showRefresh]="false"
              ></xemex-no-items-found>
            } @else {
              <xemex-point-series-chart
                [series]="card.series"
                [labels]="labels()"
                [loading]="telemetryStore.isLoading()"
                [overlays]="overlaysByCard().get(card.key) ?? []"
                [barsAsLines]="chartTypeOf(card.key) === 'line'"
              ></xemex-point-series-chart>
            }
            @if (card.key === 'energy' && forecastSummary(); as summary) {
              <p class="text-sm text-text-secondary" data-testid="pv-forecast-summary">
                {{
                  'installations.insights.forecast.summary'
                    | translate: { measured: summary.measured, expected: summary.expected }
                }}
              </p>
            }
            <xemex-source-strip
              [series]="card.series"
              [timezone]="timezone()"
              [latestReadings]="latestReadings()"
              [stateLink]="dataSourcesLink()"
            ></xemex-source-strip>
          </xemex-card>
        } @else {
          <xemex-performance-ratio-insights
            [ratios]="performanceRatios()"
            [trend]="performanceTrend()"
            [anchorDate]="performanceAnchorDate()"
            [loading]="pvPerformanceStore.isLoading()"
          ></xemex-performance-ratio-insights>
        }
      }
    </xemex-card-grid>
    <xemex-installation-data-table [installation]="installation()"></xemex-installation-data-table>
  }
</div>
